import { Link } from "react-router-dom";
import { SITE } from "@/content/site";
import logo from "@/assets/logo.png";

// Workshop-only footer nav (lab's Enterprise/AI/Demos columns dropped).
const FOOTER_LINKS: { label: string; to: string }[] = [
  { label: "Platform", to: "/platform" },
  { label: "Digital twin", to: "/digital-twin" },
  { label: "Book a demo", to: "/book-demo" },
];

export function Footer() {
  return (
    <footer className="border-t border-border bg-surface">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-6 py-12 text-sm text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
        <span className="flex items-center gap-2 font-extrabold tracking-tight text-foreground">
          <img src={logo} alt="" className="h-6 w-6 rounded" width={24} height={24} />
          {SITE.name}
        </span>
        <nav className="flex flex-wrap gap-x-6 gap-y-2">
          {FOOTER_LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="transition-colors hover:text-foreground">
              {l.label}
            </Link>
          ))}
          <a
            href={SITE.appUrl}
            target="_blank"
            rel="noopener"
            className="transition-colors hover:text-foreground"
          >
            Open the Workshop →
          </a>
        </nav>
      </div>
    </footer>
  );
}
